import type { ObjectLike } from '@skedulo/horizon-types'
import { useTemplate } from '../hooks'

export interface ITemplateContentProps {
  content: string
  context?: ObjectLike
}

export const TemplateContent = ({
  content,
  context,
}: ITemplateContentProps) => {
  const template = useTemplate({ content, context })
  const { result } = template
  return <>{result}</>
}
